export class PubSub {
    constructor() {
        this.listeners = new Map();
        this.fireEvent = (event, listenerType) => {
            listenerType = listenerType || event.type;
            const listeners = listenerType && this.listeners.get(listenerType);
            if (listeners) {
                listeners.forEach(l => l(event));
            }
        };
        this.messageListener = ({ data, source }) => {
            let event = null;
            try {
                event = Object.assign(Object.assign({}, data), { source });
            }
            catch (_a) {
                // unknown event
            }
            finally {
                if (event) {
                    this.fireEvent(event);
                    this.fireEvent(event, '*');
                    if (event.payload) {
                        console.info('sub:', event);
                    }
                }
            }
        };
        this.subscribe = (type, listener) => {
            if (!this.listeners.get(type)) {
                this.listeners.set(type, []);
            }
            this.listeners.get(type).push(listener);
            return {
                unsubscribe: () => {
                    const listeners = this.listeners.get(type);
                    if (listeners) {
                        const idx = listeners.indexOf(listener);
                        if (idx !== -1) {
                            listeners.splice(listeners.indexOf(listener), 1);
                        }
                    }
                },
            };
        };
        this.publish = (type, payload, target = window) => {
            console.info('pub:', type, payload);
            target.postMessage({ type, payload }, '*');
        };
        this.destroy = () => {
            window.removeEventListener('message', this.messageListener);
            this.listeners.clear();
        };
        window.addEventListener('message', this.messageListener);
    }
}
//# sourceMappingURL=pubsub.js.map